import {NEW_SEARCH_WIDGET} from "../../new-search-widget.consts";
import {AnalyticsEventHandler} from "../../../../infrastructure/handlers/analytics-event-handler";
import {AnalyticsService} from "../../../../third-party-services/analytics/analytics-service";
import {NewSearchWidgetClearEvent} from "../../models/analytics/new-search-widget.clear-event";

export class NewSearchWidgetClearEventHandler extends AnalyticsEventHandler {
  type = NEW_SEARCH_WIDGET.ACTION_TYPES.ANALYTICS.onClearClickEvent;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = NewSearchWidgetClearEvent;
  }
}
